import { Alert, AlertIcon, Box } from '@chakra-ui/react';
import Field from 'components/general/Field';
import { useLocationsQuery } from 'generated/graphql';
import { useFormContext, useWatch } from 'react-hook-form';

function ContractForm() {
  const { control } = useFormContext();
  const [eSign, locationId] = useWatch({ control, name: ['eSign', 'locationId'] });
  const { loading, data } = useLocationsQuery();

  if (loading || !data) return null;

  const locations = data.locations.edges.map(edge => edge.node!);
  const suites = locationId ? locations.find(({ id }) => id === locationId)!.availableSuites : [];

  return (
    <Box>
      <Field
        name="startOn"
        label="Start Date"
        type="date"
        register={{ required: 'Start date is required' }}
      />
      <Field
        name="endOn"
        label="End Date"
        type="date"
        register={{ required: 'End date is required' }}
        mt={4}
      />
      <Field
        name="locationId"
        label="Location"
        type="select"
        placeholder={locations.length ? 'Select a location' : "You don't have any locations"}
        register={{ required: 'Location is required' }}
        mt={4}
      >
        {locations.map(locationItem => (
          <option key={locationItem.id} value={locationItem.id}>
            {locationItem.address}
          </option>
        ))}
      </Field>
      <Field
        name="suite"
        label="Suite"
        type="select"
        placeholder={locationId ? 'Select a suite' : 'Select a location first'}
        register={{ required: 'Suite is required', valueAsNumber: true }}
        isDisabled={!locationId}
        mt={4}
      >
        {suites.map(suiteItem => (
          <option key={suiteItem} value={suiteItem}>
            Suite #{suiteItem}
          </option>
        ))}
      </Field>
      <Field
        name="baseRent"
        label="Base Rent"
        type="money"
        register={{ required: 'Base rent is required' }}
        mt={4}
      />
      <Field
        name="weeklyRent"
        label="Weekly Rent"
        type="money"
        register={{ required: 'Weekly rent is required' }}
        mt={4}
      />
      <Field
        name="securityDeposit"
        label="Security Deposit"
        type="money"
        register={{ required: 'Security deposit is required' }}
        mt={4}
      />

      <Field name="eSign" label="Send contract for eSignature" type="checkbox" mt={10} />

      {eSign && (
        <Alert status="warning" mt={10} mb={4}>
          <AlertIcon />
          By clicking &quot;Save&quot; below, an email will be sent to the client with a link to
          eSign the contract documents.
        </Alert>
      )}
    </Box>
  );
}

export default ContractForm;
